import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";

function Home() {
  useEffect(() => {
    const ensureLink = (id, href) => {
      if (document.getElementById(id)) return;
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    };

    const ensureScript = (id, src) => {
      if (document.getElementById(id)) return;
      const script = document.createElement("script");
      script.id = id;
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    };

    ensureLink(
      "bootstrap-css",
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css",
    );
    ensureLink(
      "bootstrap-icons",
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css",
    );
    ensureScript(
      "bootstrap-bundle",
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js",
    );
  }, []);

  const brand = useMemo(
    () => ({
      name: "XWaySpark",
      domain: "xwayspark.com",
      tagline: "Find parking. Rent it out. Simple.",
    }),
    [],
  );

  const [search, setSearch] = useState({
    location: "",
    vehicle: "Car",
    from: "",
    to: "",
  });

  const featured = useMemo(
    () => [
      {
        title: "Secure Covered Parking",
        meta: "Near Metro • CCTV • 24/7 Access",
        price: "₹1,499",
        period: "/month",
        distance: "0.8 km",
        badge: "Verified",
        icon: "bi-shield-check",
      },
      {
        title: "Bike Parking (Gated)",
        meta: "Society Parking • Well Lit",
        price: "₹399",
        period: "/month",
        distance: "1.6 km",
        badge: "Popular",
        icon: "bi-bicycle",
      },
      {
        title: "Daily Car Spot",
        meta: "Near Market • Easy Entry",
        price: "₹120",
        period: "/day",
        distance: "2.1 km",
        badge: "Best Value",
        icon: "bi-cash-coin",
      },
    ],
    [],
  );

  const onSubmitSearch = (e) => {
    e.preventDefault();
    // Wire this to your search route/API later
    // For now, keep it clean & UI-focused:
    alert(
      `Searching parking in "${search.location || "your area"}" for ${
        search.vehicle
      }`,
    );
  };

  return (
    <>
      <style>{`
        :root{
          --xs-bg: #0b1220;
          --xs-card: rgba(255,255,255,.06);
          --xs-border: rgba(255,255,255,.14);
          --xs-text: rgba(255,255,255,.88);
          --xs-muted: rgba(255,255,255,.62);
          --xs-accent: #7c3aed;
          --xs-accent2: #22c55e;
        }
        body{
          background: radial-gradient(1200px 700px at 20% -10%, rgba(124,58,237,.35), transparent 60%),
                      radial-gradient(900px 500px at 90% 10%, rgba(34,197,94,.18), transparent 55%),
                      linear-gradient(180deg, #070b14 0%, #050816 100%);
          color: var(--xs-text);
        }
        .xs-nav{
          backdrop-filter: blur(10px);
          background: rgba(8, 12, 24, .62);
          border-bottom: 1px solid rgba(255,255,255,.08);
        }
        .xs-brand-badge{
          width: 40px; height: 40px; border-radius: 14px;
          display: grid; place-items: center;
          background: linear-gradient(135deg, rgba(124,58,237,.95), rgba(34,197,94,.75));
          box-shadow: 0 10px 30px rgba(124,58,237,.22);
          color: white;
        }
        .xs-hero{
          padding-top: 6.5rem;
          padding-bottom: 4rem;
        }
        .xs-pill{
          display: inline-flex;
          align-items: center;
          gap: .5rem;
          padding: .5rem .75rem;
          border: 1px solid rgba(255,255,255,.14);
          background: rgba(255,255,255,.05);
          border-radius: 999px;
          color: var(--xs-muted);
        }
        .xs-card{
          background: rgba(255,255,255,.06);
          border: 1px solid rgba(255,255,255,.10);
          border-radius: 18px;
          box-shadow: 0 20px 55px rgba(0,0,0,.35);
        }
        .xs-card-soft{
          background: rgba(31, 31, 31, 0.04);
          border: 1px solid rgba(255,255,255,.10);
          border-radius: 18px;
        }
        .xs-input, .xs-select{
          background: rgba(255,255,255,.06) !important;
          border: 1px solid rgba(255,255,255,.14) !important;
          color: rgba(255,255,255,.88) !important;
          border-radius: 14px !important;
        }
        .xs-input::placeholder{ color: rgba(255,255,255,.45) !important; }
        .xs-btn-primary{
          background: linear-gradient(135deg, rgba(124,58,237,1), rgba(34,197,94,1));
          border: 0;
          border-radius: 14px;
          box-shadow: 0 12px 30px rgba(124,58,237,.25);
        }
        .xs-btn-primary:hover{ filter: brightness(1.05); }
        .xs-btn-outline{
          border-radius: 14px;
          border: 1px solid rgba(255,255,255,.18);
          background: rgba(255,255,255,.04);
          color: rgba(255,255,255,.86);
        }
        .xs-divider{
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.16), transparent);
        }
        .xs-section{
          padding: 4rem 0;
        }
        .xs-badge{
          border: 1px solid rgba(255,255,255,.16);
          background: rgba(255,255,255,.06);
          color: rgba(255,255,255,.78);
        }
        .xs-icon{
          width: 44px; height: 44px; border-radius: 14px;
          display: grid; place-items: center;
          background: rgba(124,58,237,.18);
          border: 1px solid rgba(124,58,237,.26);
          color: rgba(255,255,255,.9);
        }
        .xs-stat{
          border: 1px solid rgba(255,255,255,.10);
          background: rgba(255,255,255,.04);
          border-radius: 18px;
        }
        .xs-footer{
          border-top: 1px solid rgba(255,255,255,.10);
          background: rgba(0,0,0,.15);
        }
        .accordion-button{
          background: rgba(255,255,255,.04) !important;
          color: rgba(255,255,255,.88) !important;
          border-radius: 14px !important;
        }
        .accordion-item{
          background: transparent !important;
          border: 1px solid rgba(255,255,255,.10) !important;
          border-radius: 16px !important;
          overflow: hidden;
        }
        .accordion-button::after{ filter: invert(1) opacity(.8); }
        .accordion-body{ color: rgba(255,255,255,.72); }
        a{ color: inherit; }
      `}</style>

      {/* NAVBAR */}
      <nav className="navbar navbar-expand-lg fixed-top xs-nav">
        <div className="container py-0">
          <span className="navbar-brand d-flex align-items-center gap-2">
            <h3 className="text-white m-0 ls-sm">XWaySpark</h3>
          </span>

          <div className="collapse navbar-collapse" id="xsNav">
            <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-2">
              <li className="nav-item">
                <a
                  className="nav-link text-white-50 fw-normal ls-sm"
                  href="#how"
                >
                  How it works
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link text-white-50 fw-normal ls-sm"
                  href="#owners"
                >
                  For Owners
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link text-white-50 fw-normal ls-sm"
                  href="#testimonial"
                >
                  Testimonial
                </a>
              </li>
              <li className="nav-item">
                <Link to="/" className="nav-link text-white-50 fw-normal ls-sm">
                  Terms / Privacy Policy
                </Link>
              </li>
              <li className="nav-item ms-lg-7 ps-lg-3">
                <a className="btn btn-light rounded-3 px-4 py-2 ls-sm" href="#">
                  <span className="mx-2">Contact Us</span>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="btn xs-btn-primary rounded-3 text-white px-4 py-2 ls-sm"
                  href="https://play.google.com/store/apps/details?id=com.xwayspark&hl=en_SG"
                  target="_blank"
                >
                  <span className="mx-2">
                    <i className="bi bi-download me-2" />
                    Download App
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <header id="features" className="xs-hero">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-7">
              <span className="text-uppercase text-secondary fw-semibold">
                XWaySpark &mdash; India’s Trusted Parking Marketplace
              </span>
              <h1 className="fw-bold mb-3 lh-1">
                Parking for rent—near you,
                <br />
                when you need it.
              </h1>
              <p
                className="lead lh-sm mb-4"
                style={{ color: "rgba(255,255,255,.72)" }}
              >
                {brand.name} helps parkers / drivers quickly find and rent
                verified parking spots for{" "}
                <span className="text-white">cars</span> and{" "}
                <span className="text-white">bikes</span>. Owners can list
                spaces with photos, pricing, and availability.
              </p>

              <div className="xs-divider my-4" />

              {/* STATS */}
              <div className="row g-2">
                <div className="col-sm-4">
                  <div className="xs-stat rounded-4 p-3 h-100">
                    <div className="text-white-50 small">Avg. setup</div>
                    <div className="fw-bold fs-5">2 minutes</div>
                    <div className="text-white-50 small lh-1">
                      List your space with photos.
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="xs-stat rounded-4 p-3 h-100">
                    <div className="text-white-50 small">Search speed</div>
                    <div className="fw-bold fs-5">Instant</div>
                    <div className="text-white-50 small lh-1">
                      Find spots by pincode/city.
                    </div>
                  </div>
                </div>
                <div className="col-sm-4">
                  <div className="xs-stat rounded-4 p-3 h-100">
                    <div className="text-white-50 small">Flexible rent</div>
                    <div className="fw-bold fs-5">Day / Month</div>
                    <div className="text-white-50 small lh-1">
                      Choose what suits your routine.
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-2 xs-card-soft rounded-4 p-3">
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="xs-icon"
                    style={{
                      background: "rgba(34,197,94,.16)",
                      borderColor: "rgba(34,197,94,.28)",
                    }}
                  >
                    <i className="bi bi-wallet2 fs-5" />
                  </div>
                  <div>
                    <div className="fw-semibold lh-1">
                      Owners earn monthly income
                    </div>
                    <div className="text-white-50 small">
                      List a spare driveway / garage / society slot and rent it
                      out.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* HERO SIDE PANEL */}
            <div className="col-lg-5 d-flex align-items-center justify-content-center">
              <img src="/assets/images/parking.png" className="w-100" />
            </div>
          </div>
        </div>
      </header>

      {/* ABOUT US */}
      <section className="pt-6 pb-8 bg-white text-dark">
        <div className="container">
          <div className="row align-items-center justify-content-center g-5">
            <div className="col-lg-8 col-12 text-center">
              <span className="text-uppercase text-secondary fw-semibold">
                About XWaySpark
              </span>
              <h2 className="fw-bold mt-2">Smarter Parking. Better Cities.</h2>
              <p className="lead text-dark mt-3 lh-1 ls-sm">
                XWaySpark is a modern parking rental marketplace that connects
                parkers / drivers looking for safe parking spaces with owners
                who want to earn from unused parking spots.
              </p>
              <p className="lead text-dark mt-3 lh-1 ls-sm">
                Whether it’s a driveway, garage or society slot — our platform
                makes it easy to list, discover, and rent parking spaces by
                pincode or city.
              </p>
              <div className="row g-2 mt-4 justify-content-center">
                <div className="col-lg-4 col-8">
                  <div className="mt-2 bg-danger-soft rounded-4 p-3">
                    <h4 className="fw-bold m-0 lh-1 ls-sm">1,000+</h4>
                    <p className="text-secondary ls-sm mb-0">
                      Parking Spots Listed
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-8">
                  <div className="mt-2 xs-card-soft rounded-4 p-3">
                    <h4 className="fw-bold m-0 lh-1 ls-sm">5,000+</h4>
                    <p className="text-secondary ls-sm mb-0">Happy Users</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" className="xs-section pb-4 pt-8">
        <div className="container">
          <div className="xs-card p-4 p-md-5 rounded-5">
            <div className="row g-4 align-items-center">
              <div className="col-lg-6">
                <h3 className="fw-bold mb-0">How it works &mdash; Parking</h3>
                <p className="mb-4" style={{ color: "rgba(255,255,255,.7)" }}>
                  Two flows, renters find parking fast; owners list space and
                  earn.
                </p>

                <div className="d-grid gap-2">
                  {[
                    {
                      step: "01",
                      title: "Search a location",
                      desc: "Enter pincode/city, choose car or bike, and filter by duration.",
                      icon: "bi-search",
                    },
                    {
                      step: "02",
                      title: "Choose best spot",
                      desc: "View photos, access notes, security, and price to select the best spot.",
                      icon: "bi-ui-checks-grid",
                    },
                    {
                      step: "03",
                      title: "Book & park",
                      desc: "Confirm details and park with confidence—no last-minute stress.",
                      icon: "bi-check2-circle",
                    },
                  ].map((s, i) => (
                    <div key={i} className="xs-card-soft p-3">
                      <div className="d-flex gap-3">
                        <div className="xs-icon">
                          <i className={`bi ${s.icon} fs-5`} />
                        </div>
                        <div className="flex-grow-1">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="fw-semibold lh-sm">{s.title}</div>
                          </div>
                          <div className="text-white-50">{s.desc}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-4 d-flex flex-wrap gap-2">
                  <a
                    href="#listings"
                    className="btn xs-btn-primary text-white px-5 py-2"
                  >
                    Find Parking Now
                  </a>
                  <a href="#owners" className="btn xs-btn-outline px-5 py-2">
                    List as Owner
                  </a>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="row g-2">
                  <div className="col-12">
                    <div className="xs-card-soft p-4">
                      <div className="d-flex align-items-center gap-3 mb-2">
                        <div
                          className="xs-icon"
                          style={{
                            background: "rgba(34,197,94,.16)",
                            borderColor: "rgba(34,197,94,.28)",
                          }}
                        >
                          <i className="bi bi-building-check fs-5" />
                        </div>
                        <h5 className="mb-0">For Owners</h5>
                      </div>
                      <p
                        className="mb-0 lh-sm"
                        style={{ color: "rgba(255,255,255,.7)" }}
                      >
                        Upload photos, set pricing, add entry instructions, and
                        start getting booking requests.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="xs-card-soft p-4 h-100">
                      <div className="fw-semibold mb-2">
                        <i className="bi bi-camera me-2" /> Listing quality
                      </div>
                      <div className="text-white-50 lh-sm">
                        Clear photos + accurate dimensions = faster bookings.
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="xs-card-soft p-4 h-100">
                      <div className="fw-semibold mb-2">
                        <i className="bi bi-clock-history me-2" /> Availability
                      </div>
                      <div className="text-white-50 lh-sm">
                        Set time windows (day/night/24x7) to match your space.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION & VISION */}
      <section className="pb-0 pt-4">
        <div className="container">
          <div className="row g-3">
            {/* Mission */}
            <div className="col-lg-6">
              <div className="px-5 py-4 bg-white text-dark text-center rounded-5 h-100 shadow">
                <div className="mt-2 mb-4">
                  <div className="mb-2">
                    <i className="bi bi-bullseye fs-1 text-success"></i>
                  </div>
                  <h4 className="fw-bold">Our Mission</h4>
                  <h6 className="text-dark lh-sm ls-sm fw-normal opacity-75">
                    To simplify urban parking by creating a transparent and
                    accessible marketplace where users can easily find safe
                    parking spaces and owners can generate steady income from
                    unused properties.
                  </h6>
                </div>
              </div>
            </div>

            {/* Vision */}
            <div className="col-lg-6">
              <div className="px-5 py-4 bg-white text-dark text-center rounded-5 h-100 shadow">
                <div className="mt-2 mb-4">
                  <div className="mb-2">
                    <i className="bi bi-eye-fill fs-1 text-warning"></i>
                  </div>
                  <h4 className="fw-bold">Our Vision</h4>
                  <h6 className="text-dark lh-sm ls-sm fw-normal opacity-75">
                    To become India’s most trusted parking rental platform,
                    reducing traffic congestion and making cities more
                    organized, efficient, and commuter-friendly.
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DOWNLOAD APP */}
      <section
        id="download-app"
        className="pb-5 pt-8 bg-success-soft text-white mt-n8"
      >
        <div className="container pb-3 pt-8">
          <div className="row align-items-center justify-content-center g-5">
            <div className="col-lg-6 text-center">
              <span className="text-uppercase text-secondary fw-semibold">
                Get the App
              </span>
              <h2 className="fw-bold mt-1">Find Parking Anytime, Anywhere</h2>
              <p className="lead text-light mt-3 lh-sm">
                Download the XWaySpark mobile app to search, book, and manage
                parking spaces directly from your phone.
              </p>

              <div className="d-flex gap-2 justify-content-center mt-4">
                <a
                  href="https://play.google.com/store/apps/details?id=com.xwayspark&hl=en_SG"
                  target="_blank"
                  className="btn btn-light px-5 py-2 rounded-4"
                >
                  <i className="bi bi-google-play me-2"></i>
                  Google Play
                </a>
                <a
                  href="#"
                  className="btn btn-outline-light px-5 py-2 rounded-4"
                >
                  <i className="bi bi-apple me-2"></i>
                  App Store
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OWNERS CTA */}
      <section id="owners" className="bg-white xs-section pb-8">
        <div className="container">
          <div className="xs-card p-4 p-md-5">
            <div className="row g-4 align-items-center">
              <div className="col-lg-7">
                <span className="badge rounded-3 text-white bg-danger xs-badge py-2 px-4 mb-3">
                  <i className="bi bi-cash-coin me-1" />
                  Earn from unused space
                </span>
                <h3 className="fw-bold mb-1 text-dark">
                  List your parking place and start earning
                </h3>
                <p
                  className="mb-4 lh-sm text-dark"
                  style={{ color: "rgba(255,255,255,.7)" }}
                >
                  Add images, set your rent, and define availability. Perfect
                  for driveways,
                  <br />
                  garages, society slots, and commercial spaces.
                </p>

                <div className="row g-2 mb-4 text-dark">
                  {[
                    {
                      t: "Create listing",
                      d: "Add photos, address, amenities, and rules.",
                      i: "bi-plus-square",
                    },
                    {
                      t: "Set pricing",
                      d: "Daily or monthly rent with flexible access.",
                      i: "bi-currency-rupee",
                    },
                    {
                      t: "Receive bookings",
                      d: "Manage requests and keep control.",
                      i: "bi-bell",
                    },
                  ].map((x, idx) => (
                    <div key={idx} className="col-md-4">
                      <div className="xs-card-soft p-3 rounded-4 h-100">
                        <div className="fw-semibold mb-1 text-dark">
                          <i className={`bi ${x.i} me-2`} />
                          {x.t}
                        </div>
                        <div className="small text-dark">{x.d}</div>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="d-flex flex-wrap gap-2">
                  <button
                    className="btn xs-btn-primary rounded-3 text-white px-5 py-2"
                    onClick={() =>
                      alert("Open owner onboarding (hook up later).")
                    }
                  >
                    <i className="bi bi-building-add me-2" />
                    Create Owner Listing
                  </button>
                  <button
                    className="btn btn-outline-dark px-5 rounded-3 py-2"
                    onClick={() =>
                      alert("Show owner FAQ / policies (hook up later).")
                    }
                  >
                    <i className="bi bi-file-earmark-text me-2" />
                    Owner Guidelines
                  </button>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="rounded-4 bg-dark-soft p-4">
                  <div className="d-flex align-items-center text-dark gap-3">
                    <div className="xs-icon">
                      <i className="bi bi-stars fs-5" />
                    </div>
                    <div>
                      <div className="fw-semibold text-dark lh-1">
                        Pro listing checklist
                      </div>
                      <div className="small text-dark">
                        Improve trust & conversions
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-2 xs-card-soft p-4">
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <div className="small text-dark">
                        Need help onboarding?
                      </div>
                      <div className="fw-semibold text-dark lh-1">
                        Owner Support
                      </div>
                    </div>
                    <button
                      className="btn btn-dark px-4 rounded-3"
                      onClick={() =>
                        alert("Open contact/support (hook up later).")
                      }
                    >
                      <i className="bi bi-chat-dots me-2" />
                      Contact
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHY US SECTION */}
      <section className="py-5 bg-white">
        <div className="container mb-2">
          <div className="text-center mb-5">
            <span className="text-uppercase text-secondary fw-semibold">
              Why Choose Us
            </span>
            <h2 className="fw-bold text-dark my-1">
              Why Parkers / Drivers & Owners Choose XWaySpark
            </h2>
            <p className="text-muted lh-1">
              Smart parking solutions designed for both drivers and property
              owners.
            </p>
          </div>

          <div className="row g-3">
            <div className="col-lg-3 col-md-6">
              <div className="card shadow border-extralight h-100 px-lg-5 py-lg-4 p-4 text-center rounded-4">
                <div className="mb-3">
                  <i className="bi bi-search fs-2 text-primary"></i>
                </div>
                <h5 className="fw-semibold">Easy Parking Search</h5>
                <p className="text-muted small lh-sm">
                  Quickly find available parking spaces near you using pincode
                  or city search.
                </p>
              </div>
            </div>

            {/* CARD 2 */}
            <div className="col-lg-3 col-md-6">
              <div className="card shadow border-extralight h-100 px-lg-5 py-lg-4 p-4 text-center rounded-4">
                <div className="mb-3">
                  <i className="bi bi-shield-check fs-2 text-success"></i>
                </div>
                <h5 className="fw-semibold">Verified Parking Spots</h5>
                <p className="text-muted small lh-sm">
                  All listed parking spaces are verified to ensure safety,
                  reliability, and convenience.
                </p>
              </div>
            </div>

            {/* CARD 3 */}
            <div className="col-lg-3 col-md-6">
              <div className="card shadow border-extralight h-100 px-lg-5 py-lg-4 p-4 text-center rounded-4">
                <div className="mb-3">
                  <i className="bi bi-cash-stack fs-2 text-warning"></i>
                </div>
                <h5 className="fw-semibold">Earn from Your Space</h5>
                <p className="text-muted small lh-sm">
                  Property owners can list unused parking spaces and generate
                  extra monthly income.
                </p>
              </div>
            </div>

            {/* CARD 4 */}
            <div className="col-lg-3 col-md-6">
              <div className="card shadow border-extralight h-100 px-lg-5 py-lg-4 p-4 text-center rounded-4">
                <div className="mb-3">
                  <i className="bi bi-lightning-charge fs-2 text-danger"></i>
                </div>
                <h5 className="fw-semibold">Quick & Smart Booking</h5>
                <p className="text-muted small lh-sm">
                  Book parking instantly with transparent pricing and real-time
                  availability.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="pt-7 pb-6">
        <div className="container" id="testimonial">
          <div className="row mb-2">
            <div className="row text-center">
              <div className="col-md-12 px-lg-8">
                <span className="text-uppercase text-secondary fw-semibold ls-md">
                  TESTIMONIAL
                </span>
                <h3 className="fw-semibold ls-sm text-white lh-1 mt-1">
                  What People Say About XWaySpark
                </h3>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-4 col-12">
              <div>
                <span className="text-uppercase fw-semibold text-danger fs-5 ls-sm">
                  Real Parking Experiences
                </span>
                <h3 className="fw-semibold ls-sm text-white lh-1 mt-1">
                  Real Experiences from Renters & Owners
                </h3>
                <p className="lead fs-6 fw-normal lh-sm mb-4">
                  Genuine stories that reflect safety, convenience, and
                  transparent pricing. From daily parking near markets to
                  monthly slots near offices—XWaySpark makes parking easy.
                </p>
                <a
                  href="#"
                  target="_blank"
                  rel="noreferrer"
                  className="btn border-1 bg-dark text-white fw-normal w-auto me-2 px-5 me-lg-0 rounded-pill"
                >
                  Google Reviews
                </a>
              </div>
            </div>

            <div className="col-lg-8 col-12">
              <div
                id="testimonialBanner"
                className="carousel slide"
                data-bs-ride="carousel"
              >
                <div className="carousel-inner">
                  {/* Slide 1 */}
                  <div className="carousel-item active">
                    <div className="px-8 d-flex align-items-center pb-4 pt-1">
                      <div className="d-flex flex-column px-2 mx-lg-8">
                        <div className="d-flex flex-column gap-3 mt-4">
                          <div className="d-flex flex-column">
                            <p className="mb-0 lh-sm mt-1 mb-2 fs-6">
                              I found a covered car parking spot near my office
                              in minutes using the pincode search. The photos
                              and entry instructions were accurate. I liked
                              XWaySpark and recommended to all.
                            </p>
                            <div className="mt-2">
                              <span className="text-white fs-5 m-0 lh-1 mt-2 fw-medium ls-1">
                                Aarav Sharma
                              </span>
                              <p className="mb-0 lh-sm m-0 fs-6 text-light">
                                12/01/2026
                              </p>
                            </div>
                          </div>
                          <div className="lh-1">
                            <span className="align-text-top ms-2">
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Slide 2 */}
                  <div className="carousel-item">
                    <div className="px-8 d-flex align-items-center pb-4 pt-1">
                      <div className="d-flex flex-column px-2 mx-lg-8">
                        <div className="d-flex flex-column gap-3 mt-4">
                          <div className="d-flex flex-column">
                            <p className="mb-0 lh-sm mt-1 mb-2 fs-6">
                              As a bike rider, I needed a safe gated spot near
                              my hostel. XWaySpark had clear options with
                              pricing per month, and booking was quick. Great
                              experience overall.
                            </p>
                            <div className="mt-2">
                              <span className="text-white fs-5 m-0 lh-1 mt-2 fw-medium ls-1">
                                Meera Verma
                              </span>
                              <p className="mb-0 lh-sm m-0 fs-6 text-light">
                                28/12/2025
                              </p>
                            </div>
                          </div>
                          <div className="lh-1">
                            <span className="align-text-top ms-2">
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Slide 3 */}
                  <div className="carousel-item">
                    <div className="px-8 d-flex align-items-center pb-4 pt-1">
                      <div className="d-flex flex-column px-2 mx-lg-8">
                        <div className="d-flex flex-column gap-3 mt-4">
                          <div className="d-flex flex-column">
                            <p className="mb-0 lh-sm mt-1 mb-2 fs-6">
                              I listed my unused society parking slot with
                              photos and details. Within a week I started
                              getting monthly rental inquiries. The listing flow
                              is simple and looks professional.
                            </p>
                            <div className="mt-2">
                              <span className="text-white fs-5 m-0 lh-1 mt-2 fw-medium ls-1">
                                Karan Patel
                              </span>
                              <p className="mb-0 lh-sm m-0 fs-6 text-light">
                                05/02/2026
                              </p>
                            </div>
                          </div>
                          <div className="lh-1">
                            <span className="align-text-top ms-2">
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-fill text-warning me-1 fs-6"></i>
                              <i className="bi bi-star-half text-warning me-1 fs-6"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-5">
                  <button
                    className="carousel-control-prev"
                    type="button"
                    data-bs-target="#testimonialBanner"
                    data-bs-slide="prev"
                  >
                    <div className="button-md-circle bg-secondary">
                      <i className="bi bi-chevron-left fs-4 text-white"></i>
                    </div>
                  </button>
                  <button
                    className="carousel-control-next"
                    type="button"
                    data-bs-target="#testimonialBanner"
                    data-bs-slide="next"
                  >
                    <div className="button-md-circle bg-secondary">
                      <i className="bi bi-chevron-right fs-4 text-white"></i>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HERO */}
      <section id="features" className="xs-hero bg-white pt-5">
        <div className="container">
          <div className="row g-5 justify-content-center">
            <div className="col-lg-10 d-flex flex-column justify-content-center text-center">
              <span className="text-uppercase text-secondary fw-semibold">
                Why&nbsp; XWaySpark
              </span>

              <h2 className="fw-bold mb-3 lh-1 text-dark">
                Bridging Drivers and Smart Parking Spaces
              </h2>

              <p
                className="lead lh-sm mb-4 text-dark"
                style={{ color: "rgba(255,255,255,.72)" }}
              >
                XWaySpark was built with a bold vision to solve one of the most
                pressing urban challenges — finding safe, reliable, and
                accessible parking. At its core, the platform seamlessly
                connects drivers searching for parking with property owners who
                have unused spaces, transforming idle assets into valuable
                income opportunities.
              </p>

              <div className="d-flex justify-content-center">
                <div className="col-lg-7 col-12 mt-2 xs-card-soft rounded-4 p-3">
                  <div className="d-flex align-items-center text-start gap-3">
                    <di
                      className="p-4 rounded-4"
                      style={{
                        background: "rgba(59,130,246,.16)",
                        borderColor: "rgba(59,130,246,.28)",
                      }}
                    >
                      <i className="bi bi-lightbulb text-danger fs-5" />
                    </di>

                    <div>
                      <div className="text-dark fw-semibold lh-2">
                        Vision for Smarter Cities
                      </div>
                      <div className="text-dark small lh-sm mt-1">
                        Building a future where finding parking is fast,
                        reliable, and beneficial for both parkers / drivers and
                        property owners.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BUSINESS QUERY SECTION */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* LEFT SIDE */}
            <div className="col-lg-5">
              <span className="text-uppercase text-secondary fw-semibold">
                Business Contact
              </span>

              <h2 className="fw-bold mb-3 text-dark">Got a Business Query?</h2>

              <p className="text-muted mb-4 lh-sm">
                Partner with <strong>XWaySpark</strong> to expand smart parking
                solutions in your area. Whether you're a property owner,
                business partner, or investor — our team is ready to connect.
              </p>

              <div className="d-flex align-items-start mb-3">
                <i className="bi bi-envelope-fill text-primary fs-5 me-3"></i>
                <div>
                  <div className="fw-semibold text-dark lh-1">Email Us</div>
                  <small className="text-muted">business@xwayspark.com</small>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <i className="bi bi-telephone-fill text-primary fs-5 me-3"></i>
                <div>
                  <div className="fw-semibold text-dark lh-1">Call Us</div>
                  <small className="text-muted">+91 XXXXX XXXXX</small>
                </div>
              </div>

              <div className="d-flex align-items-start">
                <i className="bi bi-geo-alt-fill text-primary fs-5 me-3"></i>
                <div>
                  <div className="fw-semibold text-dark lh-1">Location</div>
                  <small className="text-muted">
                    Uttar Pradesh - Noida, India
                  </small>
                </div>
              </div>
            </div>

            {/* FORM SIDE */}
            <div className="col-lg-7">
              <div className="card border-0 shadow-lg rounded-5 p-6">
                <h5 className="fw-semibold mb-4">Send us your query</h5>

                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter your email"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter phone number"
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="form-label">Business Type</label>
                      <select className="form-select">
                        <option>Select option</option>
                        <option>Property Owner</option>
                        <option>Business Partnership</option>
                        <option>Investor</option>
                        <option>Other</option>
                      </select>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Message</label>
                      <textarea
                        rows="4"
                        className="form-control"
                        placeholder="Write your query..."
                      ></textarea>
                    </div>

                    <div className="col-12">
                      <a className="btn xs-btn-primary rounded-3 text-white px-4 py-2 ls-sm">
                        <span className="mx-2">
                          <i className="bi bi-send me-2" />
                          Submit Query
                        </span>
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="pt-8 pb-4">
        <div class="container mt-2">
          <div class="row justify-content-center text-center align-items-center">
            <div class="col-12 col-md-12 col-xxl-6 px-0">
              <div class="mb-4">
                <div className="d-flex justify-content-center mb-4">
                  <a
                    className="navbar-brand d-flex align-items-center gap-2"
                    href="#top"
                  >
                    <span className="xs-brand-badge">
                      <i className="bi bi-lightning-charge-fill fs-5" />
                    </span>
                  </a>
                </div>
                <h5 className="fw-semibold">
                  XWaySpark
                  <br />
                  India’s Trusted Parking Marketplace
                </h5>
                <p class="lead lh-sm">
                  India’s smart parking rental marketplace. Find and rent
                  parking spaces for cars and bikes or list your unused parking
                  spot and start earning.
                </p>

                <div className="d-flex justify-content-center gap-3 mt-5 mb-5">
                  <a href="#" className="text-secondary fs-5">
                    <i className="bi bi-facebook"></i>
                  </a>
                  <a href="#" className="text-secondary fs-5">
                    <i className="bi bi-instagram"></i>
                  </a>
                  <a href="#" className="text-secondary fs-5">
                    <i className="bi bi-twitter-x"></i>
                  </a>
                  <a href="#" className="text-secondary fs-5">
                    <i className="bi bi-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Home;
